import React from 'react';
import { NavLink } from 'react-router-dom';

export default function Navigation() {
	return (
		<nav>
			<NavLink to="/" style={{ paddingRight: 10 }}>
				About
			</NavLink>{' '}
			|
			<NavLink to="/EclubJoin" style={{ paddingLeft: 10 }}>
				Learn more
			</NavLink>
		</nav>
	);
}
